import * as Sentry from "@sentry/react"

import type { WSMessage } from "../types/notification.types.ts"

type InvalidFrameReason = "invalid_json" | "invalid_shape" | "non_string"

function reportInvalidFrame(
  reason: InvalidFrameReason,
  rawFrame: unknown,
  error?: unknown
) {
  Sentry.captureMessage("Discarded malformed notification WebSocket frame", {
    level: "warning",
    tags: {
      "notification.websocket.invalid_reason": reason
    },
    extra: {
      payloadType: typeof rawFrame,
      payloadLength: typeof rawFrame === "string" ? rawFrame.length : null,
      parseErrorName: error instanceof Error ? error.name : null
    }
  })
}

function isWSMessage(value: unknown): value is WSMessage {
  return (
    typeof value === "object" &&
    value !== null &&
    !Array.isArray(value) &&
    typeof (value as { type?: unknown }).type === "string"
  )
}

export function parseNotificationMessage(rawFrame: unknown): WSMessage | null {
  if (typeof rawFrame !== "string") {
    reportInvalidFrame("non_string", rawFrame)
    return null
  }

  let parsed: unknown
  try {
    parsed = JSON.parse(rawFrame)
  } catch (error) {
    reportInvalidFrame("invalid_json", rawFrame, error)
    return null
  }

  if (!isWSMessage(parsed)) {
    reportInvalidFrame("invalid_shape", rawFrame)
    return null
  }

  return parsed
}
